import useColorChange from "../../hooks/useColorChange";
import upAero from "../../assets/icons/upAero.svg";
import downAero from "../../assets/icons/downAero.svg";
import { useSocket } from "../Socket";
import { theme, Tooltip } from "antd";
import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "../../store/store";
import { findMarket, formatToINR } from "../FormateToINR/formatToINR";
import { setScriptCall } from "../../store/slice/globleSlice";
import { CurrentPrice } from "../CommanFuction/CommanFunction";
import styled from "styled-components";
import { FallOutlined, RiseOutlined } from "@ant-design/icons";

const StyledSpan = styled.span`
  color: ${(props) =>
    props?.total === 0 ? "" : props?.total > 0 ? "green" : "red"};
  font-weight: 500;
`;

const CRORE = 10000000;
const LAKH = 100000;

const FormatQuantity = React.memo(({ total }) => {
  const { formattedValue, unit } = useMemo(() => {
    const absoluteTotal = Math.abs(total);
    let value, unit;

    if (absoluteTotal >= CRORE) {
      value = absoluteTotal / CRORE;
      unit = "Cr";
    } else if (absoluteTotal >= LAKH) {
      value = absoluteTotal / LAKH;
      unit = "Lks";
    } else {
      value = absoluteTotal;
      unit = "";
    }

    const formattedValue = formatToINR(value);
    return { formattedValue, unit };
  }, [total]);

  const sign = total < 0 ? "-" : "";

  return (
    <StyledSpan total={total}>
      {sign}
      {formattedValue}
      {unit}
    </StyledSpan>
  );
});

export const PreviousM2M = React.memo(
  ({ total }) => {
    return <FormatQuantity total={total} />;
  },
  (prevProps, nextProps) => prevProps.total === nextProps.total
);

const formatPrice = (value, marketName, priceType) => {
  if (
    (marketName === "FOREX" ||
      marketName === "GLOBEX" ||
      marketName === "COMEX") &&
    priceType !== "Spread"
  ) {
    return value;
  }
  return value;
};

export function limitNumberLength(num) {
  return num;
  // Convert the number to a string
  num = parseFloat(num);

  // Check if num is a valid number
  if (isNaN(num)) {
    return 0;
  }
  let numStr = num.toString();

  // Split the number into integer and fractional parts
  let parts = numStr.split(".");
  let integerPart = parseInt(parts[0]);
  let fractionalPart = parts[1] || "";

  // Check if the number before the decimal point is less than 50
  if (integerPart < 50) {
    // If so, make sure the total length of the number is 5 after the decimal point
    if (fractionalPart.length > 5) {
      return parseFloat(integerPart + "." + fractionalPart.slice(0, 5)).toFixed(
        5
      );
    } else {
      return parseFloat(
        integerPart + "." + fractionalPart.padEnd(5, "0")
      ).toFixed(5);
    }
  }

  // For numbers greater than or equal to 50, limit the length to 6 digits
  if (integerPart.toString().length + fractionalPart.length <= 6) {
    return num.toFixed(6 - integerPart.toString().length);
  }

  // Otherwise, truncate the fractional part to fit within the 6-digit limit
  let truncatedFractionalPart = fractionalPart.slice(
    0,
    6 - integerPart.toString().length
  );

  // Combine the integer and truncated fractional parts and return the result
  return parseFloat(integerPart + "." + truncatedFractionalPart).toFixed(
    truncatedFractionalPart.length
  );
}

export function trimZeros(number) {
  return number;
  // Convert number to string to make manipulation easier
  let numStr = number.toString();

  // Find the index of the last non-zero digit or decimal point
  let lastNonZeroIndex = numStr.length - 1;
  while (
    lastNonZeroIndex >= 0 &&
    (numStr[lastNonZeroIndex] === "0" || numStr[lastNonZeroIndex] === ".")
  ) {
    lastNonZeroIndex--;
  }

  // Return the number up to the last non-zero digit or decimal point
  return numStr.substring(0, lastNonZeroIndex + 1);
}

export const M2MCalculation = React.memo(({ item, flag }) => {
  let position = item?.positions;
  let key = CurrentPrice(item);

  const pnl =
    useSelector(
      (state) => state.webSocketSlice?.webSocket?.data?.[item.symbol]?.[key]
    ) || 0;
  const ltp =
    useSelector(
      (state) => state.webSocketSlice?.webSocket?.data?.[item.symbol]?.["LTP"]
    ) || 0;

  const sum = useMemo(() => {
    let total = 0;
    position?.forEach((el) => {
      // if (el.type === flag && (ltp || pnl)) {
      //   const currentPNL = parseFloat(
      //     -el?.totalBrokerage -
      //       (el?.totalBuyPrice || 0) +
      //       (el?.totalSellPrice || 0) +
      //       (el?.totalQuantity || 0) * (pnl || ltp)
      //   );
        total += parseFloat(el?.withoutFutBrokeragePNL);
      // }
    });
    return total;
  }, [position, pnl]);

  return <PreviousM2M total={sum} />;
});

export const MemoizedCardItemPrice = ({
  item,
  onClickCell,
  priceType,
  isCustomer,
}) => {
  const buyValue = useSelector(
    (state) =>
      state.webSocketSlice?.webSocket?.data?.[item?.symbol]?.[priceType] ?? 0
  );

  const { color, backgroundColor } = useColorChange({ currentValue: buyValue });

  const formattedValue = useMemo(
    () => formatPrice(buyValue, item?.marketName, priceType),
    [buyValue, item?.marketName, priceType]
  );

  const style = useMemo(
    () => ({
      backgroundColor,
      color,
      borderRadius: "5px",
      padding: isCustomer ? "0.1rem 0.3rem" : "0.5rem 0rem", //"0.5rem 0rem"
      fontSize: isCustomer ? "1.3rem" : "1.2rem",
      fontWeight: isCustomer ? "500" : "normal",
      cursor:
        priceType === "Bid" || priceType === "Ask" ? "pointer" : "default",
    }),
    [backgroundColor, color, priceType]
  );

  return (
    <div style={style} onClick={onClickCell}>
      {formattedValue}
    </div>
  );
};

export const MemoizedCardCurrentPrice = ({ item, priceType }) => {
  let price =
    useSelector(
      (state) =>
        state.webSocketSlice?.webSocket?.data?.[item?.symbol]?.[priceType]
    ) || 0;
  let ltp =
    useSelector(
      (state) => state.webSocketSlice?.webSocket?.data?.[item?.symbol]?.["LTP"]
    ) || 0;

  const finalPrice = useMemo(() => (price === 0 ? ltp : price), [price, ltp]);

  const { color, backgroundColor } = useColorChange({
    currentValue: finalPrice,
  });

  const formattedPrice = useMemo(
    () => formatPrice(finalPrice, item?.marketName, priceType),
    [finalPrice, item?.marketName, priceType]
  );

  const style = useMemo(
    () => ({
      backgroundColor,
      color,
      borderRadius: "5px",
      padding: "0.5rem 0rem",
    }),
    [backgroundColor, color, priceType]
  );

  return <div style={style}>{formattedPrice}</div>;
};

export const MemorizedPercentageAero = ({ item, number, aero, flage }) => {
  //redux
  const Price_Change =
    useSelector(
      (state) =>
        state?.webSocketSlice?.webSocket?.data?.[item?.symbol]?.["Price_Change"]
    ) || 0;

  const percentage = useMemo(() => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: number ? "end" : "space-between",
        }}
      >
        {number == true ? <div>{Price_Change}</div> : null}
        {aero !== false && (
          <div style={{ marginLeft: number ? "1rem" : "0rem" }}>
            {/* <img
              src={Price_Change > 0 ? upAero : downAero}
              alt="Product"
              width="12"
            /> */}
            {Price_Change > 0 ? (
              <RiseOutlined style={{ color: "green", fontSize: "1.2rem" }} />
            ) : (
              <FallOutlined style={{ color: "red", fontSize: "1.2rem" }} />
            )}
          </div>
        )}
      </div>
    );
  }, [Price_Change]);

  return <>{percentage}</>;
};

export const MemorizedPriceChange = ({ item, isCustomer }) => {
  //redux
  const PriceChange =
    useSelector(
      (state) =>
        state?.webSocketSlice?.webSocket?.data?.[item?.symbol]?.["Net_Change"]
    ) || 0;

  const finalPrice = useMemo(() => {
    return item?.marketName === "FOREX" || item?.marketName === "GLOBEX"
      ? PriceChange
      : PriceChange;
  }, [PriceChange]);

  return (
    <span
      style={{ color: isCustomer ? (finalPrice >= 0 ? "green" : "red") : "" }}
    >
      {finalPrice}
    </span>
  );
};

export const MemorizedOpenClose = ({ item, priceType }) => {
  //redux
  const price =
    useSelector(
      (state) =>
        state.webSocketSlice?.webSocket?.data?.[item?.symbol]?.[priceType]
    ) || 0;

  const finalPrice = useMemo(() => {
    return findMarket(item?.marketName) ? price : price;
  }, [price, priceType]);

  return <>{finalPrice}</>;
};

export const MemorizedHighLowPrice = ({ item, priceType, index, isDark }) => {
  const token = theme.useToken().token;

  //redux
  let LTP =
    useSelector(
      (state) => state.webSocketSlice?.webSocket?.data?.[item?.symbol]?.LTP
    ) || 0;

  let price =
    useSelector(
      (state) =>
        state.webSocketSlice?.webSocket?.data?.[item?.symbol]?.[priceType]
    ) || 0;

  const HighLow = useMemo(() => {
    let backGround = false;
    let setIndex = "";
    if (LTP === price && price !== 0) {
      backGround = true;
      setIndex = index;
    }
    const memoizedColor =
      priceType === "High" ? token.marketWatchUp : token.marketWatchDown;
    return (
      <div
        style={{
          backgroundColor: backGround ? memoizedColor : "",
          color: backGround ? "white" : isDark ? "white" : "",
          borderRadius: "5px",
          padding: "0.5rem 0rem", //"0.5rem 0rem"
          display: "flex",
          justifyContent: backGround && index == setIndex ? "center" : "end",
        }}
      >
        {findMarket(item?.marketName) ? price : price}
      </div>
    );
  }, [LTP, price, priceType, isDark]);

  return <>{HighLow}</>;
};

export const MemorizedPositionData = ({ id, type }) => {
  //redux
  const value =
    useSelector((state) => state?.positionSocketSlice?.data?.[id]?.[type]) || 0;
  const { color, backgroundColor } = useColorChange({
    currentValue: value,
  });

  return (
    <div
      style={{
        color,
        backgroundColor,
        borderRadius: "5px",
        padding: "0.5rem 0rem",
      }}
    >
      {value}
    </div>
  );
};

export const PositionSocketData = ({ id, type }) => {
  //redux
  const value =
    useSelector((state) => state?.positionSocketSlice?.data?.[id]?.[type]) || 0;

  const scriptData = useSelector(
    (state) => state?.positionSocketSlice?.data?.[id]
  );

  return (


      <div>
        <p style={{ color: value > 0 ? "green" : "red" }}>
          {scriptData?.withoutFutBrokeragePNL > 0 ? `+${parseInt(scriptData?.withoutFutBrokeragePNL)}`||0 : `${parseInt(scriptData?.withoutFutBrokeragePNL)}`||0}
        </p>
       
      </div>

  );
};

export const PositionQuantity = ({ id, type, lot, market, average}) => {
  //redux
  const quantity = useSelector(
    (state) => state?.positionSocketSlice?.data?.[id]?.[type]
  );
  const Lot = useSelector(
    (state) => state?.positionSocketSlice?.data?.[id]?.[lot]
  );
  const Average = useSelector(
    (state) => state?.positionSocketSlice?.data?.[id]?.[average]
  );

  return (
      <div style={{ color: average =="BE_Avg"  ? quantity<0 ? "red" : "green" : average=="sellAverage" ? "red" : "green" }}>
    <div >
      <b>{quantity ? `${quantity}` : "-"}</b>{Average ? Average!=0 ? `(${Average})` : "" : ""}
    </div>
    <div style={{ fontSize: "10px"}}>  {market !== "NSE EQU" && <>{Lot ? `(${Lot} Lot)` : ""}</>}</div>
   
      </div>
  );
};


export const MemoizedSocketScript = React.memo(({ script }) => {
  const socketContext = useSocket();
  const dispatch = useDispatch();
  const { doSend, socketData } = socketContext;
  const allScript = store.getState()?.webSocketSlice?.webSocket?.data;
  const scriptRef = useRef(null);

  useEffect(() => {
    dispatch(setScriptCall(script));
    setTimeout(() => {
      let filteredScript = script.filter((script) => !allScript[script]);
      if (filteredScript.length >= 1) {
        doSend({
          event: "subscribeToServerMarket",
          payload: filteredScript,
        });
        scriptRef.current = filteredScript;
      }
    }, 1);
  }, [script]);
});

export const UnsubscribeSymbol = React.memo(({ script }) => {
  const socketContext = useSocket();
  const { doSend, socketData } = socketContext;

  useEffect(() => {
    if (script && script?.length > 0) {
      doSend({
        event: "unsubscribeToServerMarket",
        payload: script,
      });
    }
  }, [script]);
});
